<template>
  <div>
    <b-button
      size="sm"
      variant="success"
      class="m-2"
      @click="$bvModal.show('sendSMSModal'), sendSMSNumbers = '',sendSMSMessage = '' "
    >Odeslání SMS</b-button>

    <b-table :fields="fields" :items="tableData"></b-table>

    <b-modal size="xl" id="sendSMSModal" title="Odeslání SMS">
      <b-row>
        <b-col cols="4">
          <b-form-group label="Telefonní čísla:" label-for="sendSMSNumbers">
            <b-form-textarea v-model="sendSMSNumbers" id="sendSMSNumbers" rows="15" no-resize/>
          </b-form-group>
        </b-col>
        <b-col cols="8">
          <b-form-group label="SMS:" label-for="sendSMSMessage">
            <b-form-textarea v-model="sendSMSMessage" id="sendSMSMessage" rows="15" no-resize/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4"></b-col>
        <b-col cols="4">
          Znaků: {{countSMS(sendSMSMessage).length}} &nbsp;&nbsp;&nbsp;&nbsp;
          Zústává: {{countSMS(sendSMSMessage).remaining}} &nbsp;&nbsp;&nbsp;&nbsp;
          Počet zpráv: {{countSMS(sendSMSMessage).messages}} &nbsp;&nbsp;&nbsp;&nbsp;
        </b-col>
      </b-row>
      <template slot="modal-footer">
        <b-button size="sm" variant="success" @click="sendSMS">Odeslat</b-button>
        <b-button size="sm" variant="danger" @click="$bvModal.hide('sendSMSModal')">Zrušit</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import SmsCounter from 'sms-counter'

export default Vue.extend({
  name: 'sentSMS',
  props: {},
  components: {
  },
  data: () => ({
    tableData: [],
    sendSMSNumbers: '',
    sendSMSMessage: '',
    sendSMScounts: {},
    fields: [
      { key: 'to', label: 'Telefon' },
      { key: 'text', label: 'Text' },
      { key: 'sent', label: 'Odesláno' }
    ]

  }),
  mounted () {
    this.loadSMS()
  },
  methods: {
    countSMS (sendSMSMessage) {
      return SmsCounter.count(sendSMSMessage)
    },
    loadSMS () {
      axios
        .get('/api/v1/sms')
        .then(response => {
          for (const data of response.data) {
            if (data.sent !== null) {
              data.sent = new Date(data.sent).toISOString().substr(0, 10) + ',' + new Date(data.sent).toISOString().substr(11, 8)
            }
          }
          this.tableData = response.data
        })
        .catch(response => {
          console.log('loadSMS Error: ' + response)
        })
    },
    sendSMS () {
      console.log({ numbers: this.sendSMSNumbers, message: this.sendSMSMessage })
      this.$bvModal.hide('sendSMSModal')
      axios
        .post('/api/v1/sms/direct', { to: this.sendSMSNumbers, text: this.sendSMSMessage })
        .then(response => {
          console.log(response.data.message)
          this.loadSMS()
          this.$bvToast.toast(`Zprávy odeslané`, {
            title: 'SMS',
            variant: 'success',
            autoHideDelay: 2000
          })
        })
        .catch(err => {
          this.$bvToast.toast(`Chyba při odesílaní SMS`, {
            title: 'SMS',
            variant: 'danger',
            autoHideDelay: 2000
          })
          console.log(err)
        })
    }
  }
})
</script>
